import { useEffect, useState } from "react";
import { fetchMediaBlob } from "../api";

type Props = {
  path: string;
  alt?: string;
  className?: string;
};

export default function AuthedImg({ path, alt = "", className }: Props) {
  const [src, setSrc] = useState("");

  useEffect(() => {
    let dead = false;
    let url = "";
    setSrc("");
    void fetchMediaBlob(path)
      .then((u) => {
        if (dead) {
          if (u.startsWith("blob:")) URL.revokeObjectURL(u);
          return;
        }
        url = u;
        setSrc(u);
      })
      .catch(() => {
        if (!dead) setSrc("");
      });
    return () => {
      dead = true;
      if (url.startsWith("blob:")) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (!src) return <span className={`block h-full w-full bg-mist ${className || ""}`} />;
  return <img src={src} alt={alt} className={className} draggable={false} />;
}
